import { ReactComponent as MineIcon } from "assets/mine.svg";

export default function Splash() {
  return (
    <div className="Splash">
      <MineIcon className="Splash-icon" />
      <div className="Splash-label">[MINES]</div>
    </div>
  );
}
